import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSend } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import Toaster from "./../../../components/common/Toaster";
import ReactSelectAsync from "./../../../components/common/ReactSelectAsync";
import authService from "./../../../services/authService";
import chatService from "./../../../services/chatService";

const schema = yup.object({
  user_id: yup.object().shape({
    label: yup.string().required("Please select account."),
    value: yup.string().required("Please select account."),
  }),
  text_message: yup.string().required("Please enter a message"),
});

const NewMessage = ({ rooms, isLoading, setIsLoading, onSelect, onClose }) => {
  const user = authService.getCurrentUser();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const options = async (search, loadedOptions, { page }) => {
    const params = {
      search_query: search,
      current_page: page,
      page_size: 10,
    };

    const response = await chatService.getAvailableAccountsAsync(params);
    const { result: data, count, total_count } = response;

    const options = data.map((item) => {
      const container = {};
      container["label"] = item.name;
      container["value"] = item.user_id;

      return container;
    });

    const hasMore = total_count > count;

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);

      const chat = { ...data };
      chat["sender_id"] = user.user_id;
      chat["user_id"] = data.user_id.value;

      const result = await chatService.saveNewMessageAsync(chat);

      setIsLoading(false);
      onSelect(result);
      onClose();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelectAsync
            id="user-id-dropdown"
            name="user_id"
            title="To:"
            options={options}
            control={control}
            register={register("user_id")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <div className="w-full">
            <label htmlFor="message-textarea" className="form-label">
              Message:
            </label>
            <textarea
              id="text-message-textarea"
              name="text_message"
              className={`form-control resize-none text-sm flex items-center ${
                errors && errors.text_message && "form-invalid"
              }`}
              placeholder="Write a message..."
              rows={8}
              {...register("text_message")}
            />
            {errors && errors.text_message && (
              <div className="pt-2">
                <span className="text-sm text-red-400">
                  {errors.text_message.message}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSend className="mr-4" />}
            Send Message
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewMessage;
